import styles from './SearchResultList.less';

import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';

import JobItem from 'JobItem/JobItem';

import isEqual from 'lodash.isequal';

const idLens = job => job.id;

export default class SearchResultList extends Component {

  static propTypes = {
    jobs: PropTypes.array.isRequired
  };

  shouldComponentUpdate(nextProps) {
    const { jobs: nextJobs } = nextProps;
    const { jobs: prevJobs } = this.props;
    const nextIds = nextJobs.map(idLens).sort();
    const prevIds = prevJobs.map(idLens).sort();
    return !isEqual(nextIds, prevIds);
  }

  render() {
    const { jobs } = this.props;
    const jobsCount = jobs.length;
    const firstJob = jobs[0];
    const lastJob = jobs[jobsCount - 1];
    const isFirstJobClassic = !firstJob.isStandOut && !firstJob.isPremium;
    const isLastJobClassic = !lastJob.isStandOut && !lastJob.isPremium;
    const rootClassName = classnames({
      [styles.root]: true,
      [styles.root_isFirstJobClassic]: isFirstJobClassic,
      [styles.root_isLastJobClassic]: isLastJobClassic
    });

    return (
      <div className={rootClassName}>
        {
          jobs.map((job, jobIndex) => (
            <JobItem
              job={job}
              isFirst={jobIndex === 0}
              isLast={jobIndex === jobsCount - 1}
              key={job.id}
            />
          ))
        }
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SearchResultList/SearchResultList.js
 **/